import { Component, DoCheck, EventEmitter, Input, Output } from '@angular/core';
import { TShare } from 'src/app/project/modules/share/share.model';
import { getDisabledUserManagementTooltipText } from 'src/app/project/modules/user-management/user-management-table-cells/utils/get-disabled-user-management-cell-tooltip-text';

@Component({
  selector: 'pp-account-user-modal-shares-list-share-relationships',
  templateUrl: './account-user-modal-shares-list-share-relationships.component.html',
  styleUrl: './account-user-modal-shares-list-share-relationships.component.scss',
  standalone: false,
})
export class AccountUserModalSharesListShareRelationshipsComponent implements DoCheck {
  @Input() ppShare: TShare;
  @Output() ppShareChange = new EventEmitter<TShare>();
  @Input() ppDisabled: boolean;
  editPermission: boolean;
  disabledTooltipText: string;

  ngDoCheck(): void {
    this.setEditPermission();
  }

  private setEditPermission(): void {
    this.editPermission = this.ppShare.advancedAccessLevels.pointsRelationships.permission.edit;
    this.disabledTooltipText = getDisabledUserManagementTooltipText(this.ppShare.shareOption);
  }

  changeEditPermission(): void {
    this.editPermission = !this.editPermission;

    const newShare: TShare = { ...this.ppShare };
    newShare.advancedAccessLevels.pointsRelationships.permission.edit = this.editPermission;

    this.ppShareChange.emit(newShare);
  }
}
